import React from "react";
import styled from "styled-components/macro";

const Filler = ({ location }) => {
  return (
    <Whitespace>
      <img
        src="https://cdn.wihatoolsus.com/flags/placeholder.jpg"
        alt="placeholder logo"
      />
    </Whitespace>
  );
};

export default Filler;

const Whitespace = styled.div`
  width: 100%;
  /* height: 100%; */

  display: flex;
  justify-content: center;
  align-items: center;

  margin-left: 1.5rem;
  margin-top: 1rem;
  img {
    width: 100%;
  }
`;
